<template>
	<b-modal class="modal-lg" size="lg" :id="editDocTypesDetailsModal.id" ref="editDocTypes-modal" :title="editDocTypesDetailsModal.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetModal()">
		<template slot="modal-header" slot-scope="{ close }">
			<h5 class="modal-title text-light">{{ editDocTypesDetailsModal.title }}</h5>
			<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
		</template>
		<template slot="default">
      <div v-if="editDocTypesDetailsModal.docTypes">
        {{ t('viewAccessByDocumentTypesText', 'viewAccessByDocumentTypesText') }}
        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
          <b-input-group class="py-2"  v-for="docType in editDocTypesDetailsModal.docTypes" :key="docType.doc_type_id">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ docType.name }}</span></b-input-group-text>
            </b-input-group-prepend>
            <b-form-select v-model="docType.can_view" :options="docTypeOptions" value-field="value" text-field="text"></b-form-select>
          </b-input-group>
        </b-form-group>
      </div>
      <div v-else>
        <p class="text-center text-muted mt-3">{{ t('noDocTypes','noDocTypes') }}</p>
      </div>
      <ResponseInfo v-if="getResponseInfo.responseName == 'modalEditDocTypes'" class="mt-2"/>
    </template>
		<template slot="modal-footer" slot-scope="{ close }">
			<button type="button" class="btn btn-secondary" @click="close()">{{ t('cancelBtn', 'cancelBtn') }}</button>
			<button v-if="editDocTypesDetailsModal.docTypes && !buttonIsBusy" type="button" class="btn btn-primary" @click="updateDocTypes()">{{ t('updateBtn', 'updateBtn') }}</button>
			<b-button v-else variant="primary" disabled>
				<b-spinner small type="grow"></b-spinner>
				{{ t('updateBtn', 'updateBtn') }}
			</b-button>			
		</template>			
	</b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalEditDocTypes',
  components:{
    ResponseInfo
  },
  data () {
    return {
      editDocTypesDetailsModal: {},
			buttonIsBusy: false,
			docTypeOptions: [
				{ value: 0, text: 'no'},
				{ value: 1, text: 'yes'}
			]
    }
	},
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  methods:{
    resetModal() {
      this.$emit('hide');
    },
		// NS-10020 update document types access for admin user
		updateDocTypes() {
			this.buttonIsBusy = true
			this.$store.dispatch('endUsersAdminLogonsStore/updateAdminDocTypes', {
				docTypes: this.editDocTypesDetailsModal.docTypes,
				userId: this.editDocTypesDetailsModal.userId
			}).then(() => {
				this.buttonIsBusy = false
        this.requestAdminDocumentTypes()
			})
		},
    requestAdminDocumentTypes() {
      this.$store.dispatch('endUsersAdminLogonsStore/getAdminDocumentTypes', {
        userId: this.editDocTypesDetailsModal.userId
      }).then(response => {
        this.editDocTypesDetailsModal.docTypes = response
      })
    }
  },
  created() {
		this.editDocTypesDetailsModal = this.$attrs.modal
  },
}
</script>

<style scoped>

</style>
